export const SidebarIdGlobalSystemSettings = 'GLOBAL_SYSTEM_SETTINGS' as const;
